const projects = [
  {
    id: 1,
    title: 'Pizza Garden Website',
    category: 'Web Application',
    img1: require('@/assets/images/webApp/pizzagarden/img1.jpg'),
    img2: require('@/assets/images/webApp/pizzagarden/img2.jpg'),
    img3: require('@/assets/images/webApp/pizzagarden/img3.jpg'),
    img4: require('@/assets/images/webApp/pizzagarden/img4.jpg'),
    role: 'Project Manager, Front-end Developer',
    date: 'Mar 31, 2025',
    skills: 'Vue JS, Material UI, Firebase, SCSS, TypeScript',
    url: 'https://test.pizzagarden.ca/',
    p1: "This is an online ordering platform for Pizza Garden, a well-known pizza chain. I led the project as both project manager and front-end developer. The platform was built with Vue.js and TypeScript, and integrated Firebase for real-time data management and order tracking. A strong focus was placed on responsive UI design using Material UI and SCSS.",
    p2: "By enhancing mobile accessibility and optimizing performance, the platform achieved a 30% increase in online orders within three months of launch. Collaboration with marketing allowed us to implement analytics and conversion tracking, aligning technical delivery with business KPIs."
  },
  {
    id: 2,
    title: 'Inventory System',
    category: 'Web Application',
    img1: require('@/assets/images/webApp/inventory/img1.jpg'),
    img2: require('@/assets/images/webApp/inventory/img2.jpg'),
    img3: require('@/assets/images/webApp/inventory/img3.jpg'),
    img4: require('@/assets/images/webApp/inventory/img4.jpg'),
    role: 'Frontend Developer, UI/UX Designer',
    date: 'Aug 07, 2021',
    skills: 'Vue, Vuex, Sass, Firebase, GitHub',
    url: 'https://inventory.laruota.ca/',
    p1: "This web-based inventory management system was designed to support SMB clients in organizing and tracking stock efficiently. I was responsible for the front-end architecture, component design, and interface development using Vue.js and Vuex.",
    p2: "Integration with Firebase enabled real-time data synchronization and authentication, reducing manual errors by 60%. UI improvements based on user feedback and analytics directly supported sales strategies and improved operational workflows."
  },
  {
    id: 3,
    title: 'Goopter Website',
    category: 'Web Application',
    img1: require('@/assets/images/webApp/goopter/img1.jpg'),
    img2: require('@/assets/images/webApp/goopter/img2.jpg'),
    img3: require('@/assets/images/webApp/goopter/img3.jpg'),
    img4: require('@/assets/images/webApp/goopter/img4.jpg'),
    role: 'Front-end Developer',
    date: 'Nov 05, 2021',
    skills: 'React, WordPress, Frontity, Bootstrap, TypeScript',
    url: 'https://www.goopter.com/',
    p1: "This is the Goopter company site project. A React-based approach was selected to improve usability, SEO, and performance. As a front-end developer, I implemented the homepage, about page, and product information pages. PHP was used to bridge WordPress content with React components.",
    p2: "Following technical research, we selected Frontity as the integration layer, enabling a fast and SEO-optimized site. The project involved tight coordination between the UX and development teams, with my responsibilities centered on high-impact content sections."
  },
  {
    id: 4,
    title: 'Corporation Survey',
    category: 'Web Application',
    img1: require('@/assets/images/webApp/survey/img1.png'),
    img2: require('@/assets/images/webApp/survey/img2.png'),
    img3: require('@/assets/images/webApp/survey/img3.png'),
    img4: require('@/assets/images/webApp/survey/img4.png'),
    role: 'Developer',
    date: 'Mar 03, 2023',
    skills: 'React, Sass, Firebase, Material, GitHub',
    url: 'https://survey.androvega.ca/megabite-experience',
    p1: "This is a survey-based web application developed for internal corporate feedback and analysis. I developed key user features including authentication, data entry, and monthly analytics view, using React, Firebase, and Material UI.",
    p2: "The system was optimized for mobile users and implemented role-based access. Firebase was used to store and manage responses in real time, enabling data-driven decision making for client companies."
  },
  {
    id: 5,
    title: 'Emily Realtor Website',
    category: 'Website',
    img1: require('@/assets/images/website/realtor/img1.jpg'),
    img2: require('@/assets/images/website/realtor/img2.jpg'),
    img3: require('@/assets/images/website/realtor/img3.jpg'),
    img4: require('@/assets/images/website/realtor/img4.jpg'),
    role: 'Project Manager ,Front-end Developer',
    date: 'Nov 05, 2021',
    skills: 'WordPress Theme, PHP, JavaScript',
    url: 'https://emilyoh.ca/',
    p1: "This branding website was developed for a real estate agent in Vancouver. I customized a WordPress theme and integrated lead forms, optimizing the user journey for inquiries and property search.",
    p2: "Within two months post-launch, the agent experienced a 20% increase in inquiry volume. The site was designed with mobile-first best practices and SEO structure tailored to local real estate searches."
  },
  {
    id: 6,
    title: 'Vnex Enerygy',
    category: 'Website',
    img1: require('@/assets/images/website/vnex/img1.png'),
    img2: require('@/assets/images/website/vnex/img2.png'),
    img3: require('@/assets/images/website/vnex/img3.png'),
    img4: require('@/assets/images/website/vnex/img4.png'),
    role: 'Project Manager ,Front-end Developer, Graphic Designer',
    date: 'Mar 03, 2023',
    skills: 'Vue JS, PHP',
    url: 'https://vnexenergy.com',
    p1: "I developed a corporate website for a renewable energy startup. My responsibilities included project management, graphic design, and front-end development using Vue.js and PHP.",
    p2: "Following launch, partnership inquiries doubled due to improved UX and mobile accessibility. Visual storytelling and eco-conscious design were key to supporting the client’s branding objectives."
  },
  {
    id: 7,
    title: 'PNC Consulting LLP',
    category: 'Website',
    img1: require('@/assets/images/website/pnc/img1.png'),
    img2: require('@/assets/images/website/pnc/img2.png'),
    img3: require('@/assets/images/website/pnc/img3.png'),
    img4: require('@/assets/images/website/pnc/img4.png'),
    role: 'Project Manager ,Front-end Developer, Graphic Designer',
    date: 'Mar 03, 2023',
    skills: 'Vue JS, PHP',
    url: 'https://www.pnccpa.ca/',
    p1: "I developed a bilingual website for an accounting firm. Built with Vue.js and PHP, the site features dynamic content and language toggles for English and Japanese users.",
    p2: "Structured layout and optimized CTA placement contributed to a 28% reduction in bounce rate. Downloadable assets and FAQ sections enhanced user engagement and improved client conversion rates."
  },
  {
    id: 8,
    title: 'Neapolitan Pizza Ltd',
    category: 'Website',
    img1: require('@/assets/images/website/neapolitan/img1.jpg'),
    img2: require('@/assets/images/website/neapolitan/img2.jpg'),
    img3: require('@/assets/images/website/neapolitan/img3.jpg'),
    img4: require('@/assets/images/website/neapolitan/img4.jpg'),
    role: 'Web Designer',
    date: 'Aug 03, 2023',
    skills: 'HTML, CSS, JavaScript, jQuery',
    url: 'https://www.neapolitangroup.ca/',
    p1: "This project involved redesigning a local pizzeria’s website to modernize its visual identity. I led the front-end layout and styling efforts.",
    p2: "Improvements in navigation and mobile UX contributed to a 15% increase in mobile orders. Interactive menus and embedded maps enhanced customer usability and foot traffic."
  },
  {
    id: 9,
    title: 'Androvega Software',
    category: 'Website',
    img1: require('@/assets/images/website/androvega/img1.jpg'),
    img2: require('@/assets/images/website/androvega/img2.jpg'),
    img3: require('@/assets/images/website/androvega/img3.jpg'),
    img4: require('@/assets/images/website/androvega/img4.jpg'),
    role: 'Web Designer',
    date: 'Aug 03, 2023',
    skills: 'HTML, CSS, JavaScript, jQuery',
    url: 'https://androvega.ca/',
    p1: "This corporate site redesign focused on aligning the UI with updated brand guidelines. I worked on layout, animations, and responsive interactions using HTML, CSS, and jQuery.",
    p2: "Post-launch, session duration increased by 25% according to analytics. The clean structure and improved accessibility reinforced the company’s professional identity."
  }
];

export default projects;
